import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App } from 'antd';
import AppRoot from './App';
import './index.css';

const theme = {
  token: {
    colorPrimary: '#0A0A0A',
    colorLink: '#0A0A0A',
    borderRadius: 6,
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
    fontSize: 14,
    colorBgContainer: '#ffffff',
    colorBorder: '#e8e8e8',
  },
  components: {
    Button: {
      primaryColor: '#ffffff',
      colorPrimaryHover: '#333333',
    },
    Menu: {
      itemColor: '#666666',
      itemSelectedColor: '#0A0A0A',
      itemSelectedBg: '#f5f5f5',
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={theme}>
    <App>
      <AppRoot />
    </App>
  </ConfigProvider>
);